/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Table, Tbody, Td, Thead, Tr } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Component */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Styles */
/* Services */

/**
 * Renders DateAndTime H Component
 * @param {Object} sectionContent - Data from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} - DateAndTime Component
 */
const DateAndTime = ({ sectionContent, region, lang }) => {
  // consoleLog('sec', sectionContent);
  const config = sectionContent?.config ? sectionContent?.config : null;
  const table = sectionContent?.table?.length ? sectionContent?.table[0] : null;

  if (config === null || table === null) {
    return null;
  }

  return (
    <Box
      backgroundColor="#ffffff"
      border="1px solid #EAEAEA"
      padding="10px"
      marginTop="30px"
      className="UpcomingPrograms"
    >
      <Box>
        <StructuredTextParser
          str={render(sectionContent.programIncidenceDescription)}
          region={region}
          lang={lang}
        />
      </Box>
      <style>
        {`
            .UpcomingPrograms table, td, tr, th, thead, tbody{
              border:none !important;
            }
            #hasBorder{
              border-top:1px solid #EAEAEA !important;
            }
            `}
      </style>

      {/* {sectionContent?.dateAndTimeJson[0]?.table[0]  && ( */}
      <Table borderCollapse={'collapse'} style={{ borderCollapse: 'collapse' }}>
        <Thead>
          <Tr>
            <Td
              fontFamily="'FedraSansStd-book', sans-serif"
              fontSize="16px"
              fontWeight={'900'}
              color="#28231E"
            >
              {config.Title1}
            </Td>
            <Td
              fontFamily="'FedraSansStd-book', sans-serif"
              fontSize="16px"
              fontWeight={'900'}
              color="#28231E"
            >
              {config.Title2}
            </Td>
          </Tr>
        </Thead>
        <Tbody>
          {Object.keys(table)?.map((item, i) => {
            let main = table[item];

            return (
              <Tr key={nanoid(5)} id="hasBorder" borderTop="1px solid #EAEAEA">
                <Td
                  fontFamily="'FedraSansStd-book', sans-serif"
                  fontSize="16px"
                  color="#28231E"
                  padding="15px"
                  fontWeight={'900'}
                >
                  {formatDate(main.StartDay, config.dateFormat)}
                  <Box as="span"> </Box> {config.separator}{' '}
                  <Box as="span"> </Box>
                  {formatDate(main.EndDay, config.dateFormat)}
                </Td>
                <Td
                  fontFamily="'FedraSansStd-book', sans-serif"
                  fontSize="16px"
                  color="#28231E"
                  padding="15px"
                >
                  {formatTime(main.StartTime, config.timeFormat)}
                  <Box as="span"> </Box> {config.separator}{' '}
                  <Box as="span"> </Box>
                  {formatTime(main.EndTime, config.timeFormat)}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      {/* )} */}
    </Box>
  );
};

const monthValue = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December',
};

const twoDigit = date => {
  return date < 10 ? `0${date}` : date;
};

const formatDate = (day, pattern) => {
  const d = new Date(day);

  let date = d.getDate();
  let month = monthValue[d.getMonth()];
  // let year = d.getFullYear()

  const patterns = {
    'mmm dd': `${month?.substr(0, 3)} ${twoDigit(date)}`
  };

  return patterns[pattern];
};

const formatTime = (day, pattern) => {
  const d = new Date(day);

  return d.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  // let hour = d.getHours();
  // let h = hour % 12;
  // let minute = d.getMinutes();

  // const patterns = {
  //   'h:mm TT': `${twoDigit(h)}:${twoDigit(minute)} ${hour > 12 ? 'PM' : 'AM'}`,
  // };

  // return patterns[pattern];
};

export default DateAndTime;
